// extracted by mini-css-extract-plugin
export default {"fr-view":"QuestionEdit_fr-view__dM-ue","form":"QuestionEdit_form__GwKT7"};